(function() {

  // stx reorder
  var reorder = new function(){
    var self = this;

    this.pushQueue = function(i, data, el){
      // LOW STOCK -- add as many as possible if stock is below requested amount
      if(data[i].check_inventory){
        data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ quantity: data[i].quantity, id: data[i].id })
      }).then(function(){
        if(i >= data.length - 1){
          el.classList.remove('loading');

          fetch('/?sections=ajax-cart')
            .then(function(response){ return response.json(); })
            .then(function(data){
              var SectionHtml = data['ajax-cart'];
              document.querySelector('#cusomajax').innerHTML = SectionHtml;
              document.querySelector('body').classList.add('ajax-cart-open');
              setTimeout(function(){
                document.querySelector('#cusomajax .ajax__cart').setAttribute('open', '');
                document.querySelector('.cart-count-bubble span').innerHTML = parseInt(document.querySelector('#cart-item-count').innerHTML.replace('items',''));
              }, 100);
            });

          fetch('/cart.js')
            .then(function(response){ return response.json(); });

          return;
        } else {
          // Calls are async as required by Shopify Docs
          self.pushQueue(i+1, data, el);
        }
      });
    }

    this.listen = function(){
      var el = this;
      var ids = el.getAttribute('data-variant-ids').split(',');
      var productTitle = el.getAttribute('data-product-title').split(',');
      var quantities = el.getAttribute('data-variant-quantities').split(',');
      var inventories = el.getAttribute('data-variant-inventories').split(',');
      var inventory_policies = el.getAttribute('data-variant-inventory-policies').split(',');
      var inventory_trackers = el.getAttribute('data-variant-inventory-trackers').split(',');
      ids.splice(-1, 1);
      productTitle.splice(-1, 1);
      quantities.splice(-1, 1);
      inventories.splice(-1, 1);
      inventory_policies.splice(-1, 1);
      inventory_trackers.splice(-1, 1);

      var data = [];
      for(var i=0; i<ids.length; i++){
        data.push({
          id: ids[i],
          product_title: productTitle[i],
          quantity: quantities[i],
          inventory: inventories[i],
          check_inventory: (inventory_policies[i] == 'deny' && inventory_trackers[i] != '')
        });
      }
      el.classList.add('loading');
      self.pushQueue(0, data, el);
    }

    this.init = function(){
      document.querySelectorAll('.reorder-btn').forEach(function(btn){
        btn.addEventListener('click', self.listen);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', reorder.init);

})();
